module.exports = __webpack_public_path__ + "static/img/ct-monitor.2746e59.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/20250724/ruanjian/ct-monitor.svg
// module id = uWrp
// module chunks = 18